import ChoiceList from './components/ChoiceList';
import FormPanel from './components/FormPanel';
import SummaryCard from './components/SummaryCard';
import UserGateBar from './components/UserGateBar';
import DataTable from './components/DataTable';
import DateTimePicker from './components/DateTimePicker';
import StepperCounter from './components/StepperCounter';
import TripOptions from './components/transport/TripOptions';
import SeatMap from './components/transport/SeatMap';
import {
  RetakeCard,
  RetakeTimeline,
  RetakeConflicts,
  RetakeExportBar,
} from './components/mirea/RetakeParts';
import CampusMap from './components/mirea/CampusMap';

export { UserGateBar };

const REGISTRY = {
  choice_list: ChoiceList,
  form: FormPanel,
  summary_card: SummaryCard,
  user_gate_bar: UserGateBar,
  data_table: DataTable,
  date_time_picker: DateTimePicker,
  stepper_counter: StepperCounter,
  trip_options: TripOptions,
  seat_map: SeatMap,
  retake_card: RetakeCard,
  retake_timeline: RetakeTimeline,
  retake_conflicts: RetakeConflicts,
  retake_export_bar: RetakeExportBar,
  campus_map: CampusMap,
};

export function getComponent(name, version = 1) {
  const versioned = version > 1 ? `${name}@${version}` : name;
  return REGISTRY[versioned] || REGISTRY[name] || null;
}

export function registerComponent(name, component) {
  REGISTRY[name] = component;
}

export { REGISTRY };
